// Applies per-surface PWA identity and returns a cleanup that restores the
// previous values. Android "Install app" reads the manifest; iOS "Add to Home
// Screen" uses the document title / apple-mobile-web-app-title meta. The driver
// and customer surfaces are separate installable apps living under one SPA, so
// each swaps these at runtime instead of relying on the static index.html.
export function applyPwaBranding({ manifest, title }) {
  const link = document.getElementById("app-manifest");
  const prevManifest = link ? link.getAttribute("href") : null;
  if (link && manifest) link.setAttribute("href", manifest);

  const prevTitle = document.title;
  if (title) document.title = title;

  let appleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  const createdApple = !appleMeta;
  if (!appleMeta) {
    appleMeta = document.createElement("meta");
    appleMeta.setAttribute("name", "apple-mobile-web-app-title");
    document.head.appendChild(appleMeta);
  }
  const prevApple = appleMeta.getAttribute("content");
  if (title) appleMeta.setAttribute("content", title);

  return () => {
    if (link && prevManifest) link.setAttribute("href", prevManifest);
    document.title = prevTitle;
    if (createdApple) appleMeta.remove();
    else if (prevApple !== null) appleMeta.setAttribute("content", prevApple);
  };
}
